module.exports = __webpack_public_path__ + "static/media/close.6513645b.svg";